import { rootState } from "../../types/rootState";

export const initialUser = (state: rootState) => state.currentUser;

export const role = (state: rootState) => state.currentUser.role;

export const userId = (state: rootState) => state.currentUser.userId;